import { Theme } from "theme-ui";

export const defaultPalette = {
  white: "#fff",
  white100: "#fafafa",
  white90: "rgba(250, 250, 250, 0.9)",
  white80: "rgba(250, 250, 250, 0.8)",
  white70: "rgba(250, 250, 250, 0.7)",
  white60: "rgba(250, 250, 250, 0.6)",
  white50: "rgba(250, 250, 250, 0.5)",
  white40: "rgba(250, 250, 250, 0.4)",
  white30: "rgba(250, 250, 250, 0.3)",
  white20: "rgba(250, 250, 250, 0.2)",
  white10: "rgba(250, 250, 250, 0.1)",
  white05: "rgba(250, 250, 250, 0.05)",
  white00: "#FFFFFF00",
  // background: "#232725", // makes the canvas this color?

  black: "#0F0F0F",
  black100: "#0F0F0F",
  black90: "rgba(15, 15, 15, 0.9)",
  black80: "rgba(15, 15, 15, 0.8)",
  black70: "rgba(15, 15, 15, 0.7)",
  black60: "rgba(15, 15, 15, 0.6)",
  black50: "rgba(15, 15, 15, 0.5)",
  black40: "rgba(15, 15, 15, 0.4)",
  black30: "rgba(15, 15, 15, 0.3)",
  black20: "rgba(15, 15, 15, 0.2)",
  black10: "rgba(15, 15, 15, 0.1)",
  black05: "rgba(15, 15, 15, 0.05)",

  greyscale50: "#FAFAFA",
  greyscale100: "#F5F5F5",
  greyscale200: "#EEEEEE",
  greyscale300: "#E0E0E0",
  greyscale400: "#BDBDBD",
  greyscale500: "#9E9E9E",
  greyscale600: "#757575",

  // primary40: "rgba(255, 196, 52, 0.32)",
  primary100: "#FBEFD2",
  primary200: "#FCE4AB",
  primary300: "#FED46F",
  primary: "#FFC434",
  primary400: "#B78E29",
  primary500: "#876921",
  primary600: "#57451A",
  // primary48: "rgba(255, 196, 52, 0.52)",
  // primary32: "rgba(255, 196, 52, 0.32)",
  secondary100: "#DADAF8",
  secondary200: "#BBBAF5",
  secondary300: "#8B8BF2",
  secondary: "#5C5BEE",
  secondary400: "#4544AB",
  secondary500: "#35357E",
  secondary600: "#262652",

  success: "#85FF7A",
  error: "#FF6E64",
  warning: "#FF9255",
  focus: "#FF9EEAB0",
  info: "#0047FF",
  enabled: "#2F9665",

  wlButtonText: "#0F0F0F",
  wlButtonHover: "#FED46F",
  wlButtonFill: "#FFC434",
  wlLinkText: "#5C5BEE",
  wlAccent: "#8B8BF2",
  wlSurface: "#FAFAFA",
  wlMutedText: "rgba(15, 15, 15, 0.40)",
  wlBorderHover: "rgba(15, 15, 15, 0.30)"
};

export const colors = ({
  palette
}: {
  palette: typeof defaultPalette;
}): Theme["colors"] => ({
  palette,
  whitelabel: {
    buttonFill: palette.wlButtonFill,
    buttonText: palette.wlButtonText,
    buttonHover: palette.wlButtonHover,
    linkText: palette.wlLinkText,
    accent: palette.wlAccent,
    surface: palette.wlSurface,
    mutedText: palette.wlMutedText,
    borderHover: palette.wlBorderHover
  },
  text: {
    default: palette.black100,
    button: palette.black,
    muted: palette.black80,
    subtle: palette.black60,
    light: palette.greyscale500,
    brand: palette.primary,
    highlight: palette.secondary,
    dark: palette.black,
    error: "#AD3028"
  },
  icons: {
    default: palette.greyscale400,
    muted: palette.black30,
    subtle: palette.greyscale50,
    dark: palette.black100,
    highlight: palette.white
  },
  background: {
    default: palette.white,
    muted: palette.white100,
    subtle: palette.greyscale100,
    dark: palette.primary600,
    disabled: palette.black60,
    info: "#F5F8FF"
  },
  semantic: {
    success: palette.success,
    error: palette.error,
    warning: palette.warning,
    info: palette.info,
    disabled: palette.greyscale300,
    mist: palette.white80,
    enabled: palette.enabled
  },
  hover: {
    default: palette.black10,
    muted: palette.black10,
    subtle: palette.black05,
    brand: palette.primary300,
    highlight: palette.greyscale100,
    dark: palette.greyscale600,
    error: "#E6BFBC"
  },
  focus: {
    default: palette.secondary300,
    dark: palette.secondary400,
    muted: palette.black50,
    subtle: palette.white50
  },
  active: {
    default: palette.black05,
    muted: palette.white,
    brand: palette.primary,
    highlight: palette.secondary
  },
  inactive: {
    default: palette.black30,
    subtle: palette.greyscale50,
    dark: palette.black60
  },
  fill: {
    default: palette.primary,
    muted: palette.black05,
    subtle: palette.white00,
    brand: palette.primary,
    dark: palette.black60, // modal overlay,
    error: "#FFD4D1"
  },
  surface: {
    subtle: palette.greyscale50,
    default: palette.white100,
    muted: palette.black05,
    highlight: palette.white,
    dark: palette.black100
  },
  borders: {
    default: palette.black20,
    subtle: palette.black10,
    muted: palette.black05,
    dark: palette.black100
  }
  // the magic
  /* modes: {
    dark: {
      background: {
        default: palette.black
      },
      surface: {
        default: palette.black100,
        subtle: palette.white20
      }
    }
  } */
});
